import { render, staticRenderFns } from "./PerformanceProductEdit.vue?vue&type=template&id=63fcdc4a&scoped=true&"
import script from "./PerformanceProductEdit.vue?vue&type=script&lang=js&"
export * from "./PerformanceProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcdc4a",
  null
  
)

export default component.exports